import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { textAlign } from '@mui/system';

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    position: 'relative',
    backgroundColor: '#000',
    padding: '20px 10px 100px 10px',
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
    overflow: 'hidden',
    borderTopLeftRadius: '20px',
    borderTopRightRadius: '20px',
    borderTop: '1px solid #794100',
    [theme.breakpoints.down('lg')]: {
      padding: '20px 0',
    },
  },
  topLine: {
    width: '12%',
    height: '4px',
    backgroundColor: '#606060',
    marginBottom: '100px',
    [theme.breakpoints.down('lg')]: {
      width: '40%',
      marginBottom: '60px',
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '80%',
    [theme.breakpoints.down('lg')]: {
      width: '90%',
    },
  },
  textContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    marginBottom: '100px',
    [theme.breakpoints.down('lg')]: {
      justifyContent: 'start',
      alignItems: 'start',
      width: '100%',
      marginBottom: '40px',
    },
  },
  heading: {
    textShadow: '0px 4px 28.9px rgba(255, 255, 255, 0.15) !important',
    fontSize: '48px !important',
    fontWeight: '500 !important',
    letterSpacing: '-0.96px !important',
    background: 'linear-gradient(135deg, #FFF 30%, rgba(255, 255, 255, 0.70) 100%)',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    marginBottom: '-10px !important',
    [theme.breakpoints.down('lg')]: {
      fontSize: '32px !important',
    },
  },
  subtext: {
    marginTop: '16px !important',
    fontSize: '14px',
    color: '#bbb',
    width: '60%',
    [theme.breakpoints.down('lg')]: {
      textAlign: 'start',
      width: '80%',
    },
  },
  gridContainer: {
    width: '70% !important',
    position: 'relative',
    zIndex: 2,
    marginBottom: '80px',
    [theme.breakpoints.down('lg')]: {
      width: '100% !important',
      padding: '0 !important',
      marginBottom: '0px',
    },
  },
  featureBox: {
    background: 'linear-gradient(81deg, rgba(135, 135, 135, 0.33) -72.81%, rgba(0, 0, 0, 0.33) 74.01%)',
    borderLeft: '1px solid #C4C2E7',
    padding: '24px !important',
    fontSize: '20px !important',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start',
    textAlign: 'start',
    color: '#D2D2D2',
    height: '100px',
    marginBottom: '15px',
    [theme.breakpoints.down('lg')]: {
      padding: '14px 18px !important',
      fontSize: '14px !important',
    },
  },
  radarImage: {
    position: 'absolute',
    bottom: 0,
    left: '50%',
    transform: 'translateX(-50%)',
    width: '53%',
    height: 'auto',
    zIndex: 0,
    pointerEvents: 'none',
    [theme.breakpoints.down('sm')]: {
      width: '150%',
    },
  },
  button: {
    position: 'relative',
    width: '100%',
    zIndex: 1,
    display: 'flex',
    alignItems: 'end',
    justifyContent: 'center',
    gap: '80px',
    flexWrap: 'wrap',
    [theme.breakpoints.down('md')]: {
      flexWrap: 'wrap',
      gap: '24px',
      justifyContent: 'space-between',
    },
    [theme.breakpoints.up('lg')]: {
      flexWrap: 'wrap',
      gap: '24px',
    },
  },
  halfWidthMobile: {
    [theme.breakpoints.down('lg')]: {
      width: '38%',
    },
  },
  fullWidthMobile: {
    [theme.breakpoints.down('lg')]: {
      width: '100%',
    },
  },
  Container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '10px',
    borderBottom: '0.7px solid #FEA985',
    minWidth: '260px',
    textAlign: 'center',
    background: 'transparent',
    cursor: 'pointer',
    position: 'relative',
    transition: 'transform 0.3s ease',
    '&:hover': {
      transform: 'scale(1.03)',
    },
    [theme.breakpoints.down('lg')]: {
      minWidth: '0px',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'end',
      padding: '16px',
    },
    [theme.breakpoints.down('sm')]: {
      minWidth: '0px',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'end',
      padding: '12px',
    },
  },

  logo: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('lg')]: {
      flexDirection: 'column',
      alignItems: 'start',
    },
  },

  Icon: {
    width: '80px',
    height: 'auto',
    marginBottom: '12px',
    [theme.breakpoints.down('lg')]: {
      marginBottom: '10px',
      width: '60px',
    },
    [theme.breakpoints.down('sm')]: {
      width: '40px',
      marginBottom: '5px',
    },
  },

  Label: {
    fontSize: '14px',
    color: '#FFFFFF',
    fontWeight: 500,
    marginBottom: '12px',
    [theme.breakpoints.down('lg')]: {
      marginBottom: 0,
      fontSize: '10px',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '8px',
    },
  },

  IconArrow: {
    color: '#fff',
    fontSize: '18px !important',
    position: 'absolute',
    right: '8px',
    bottom: '8px',
    [theme.breakpoints.down('lg')]: {
      position: 'relative',
      right: '0',
      bottom: '0',
      marginLeft: 'auto',
      fontSize: '16px !important',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px !important',
    },
  },
}));
